jQuery.validator.addMethod("lessThanToday", function(value, element) {
    let today = new Date();
    let selectedDate = new Date(value);

    // Convert both dates to milliseconds and compare
    return selectedDate < today;
}, "Ingresa una fecha inferior a la de hoy.");
